import type { ReactNode } from "react";
import Regex from "./Regex";

export default (message?: ReactNode) =>
  Regex(new RegExp(/^[\p{L}\p{M}*+0-9 &\-_.,'\\"]+$/u), message);
